// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7451b80e","732":"1047f059"}[chunkId] + ".chunk.js";
};